import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/accomodation/ManageAccomodationAdd.css";
import AccomodationApi from "../../api/accomodationApi";
import { toast } from "react-toastify";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import ManagerApi from "../../api/managerApi";

const ManageAccomodationAdd = () => {
  let navigate = useNavigate();

  const [accomodationInfo, setAccomodationInfo] = useState({});
  const [managerInfo, setManagerInfo] = useState({});

  const accomodationImg = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      setAccomodationInfo((accomodationInfo) => ({
        ...accomodationInfo,
        image: file,
        imageUrl: e.target.result,
        imageDeleteFlag: true,
      }));
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const deleteImage = () => {
    setAccomodationInfo((accomodationInfo) => ({
      ...accomodationInfo,
      image: null,
      imageUrl: "",
      imageDeleteFlag: true,
    }));
  };

  const accomodationEdit = async () => {
    if (!accomodationInfo.name) {
      toast("숙소명을 입력해주세요");
      return;
    }
    if (!accomodationInfo.address) {
      toast("주소를 입력해주세요");
      return;
    }
    if (!accomodationInfo.addressDetail) {
      toast("상세주소를 입력해주세요");
      return;
    }
    if (!managerInfo.id) {
      toast("관리자 정보를 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("managerId", managerInfo.id);
      formData.append("name", accomodationInfo.name);

      formData.append("address", accomodationInfo.address);

      if (accomodationInfo.addressDetail) {
        formData.append("addressDetail", accomodationInfo.addressDetail);
      }

      formData.append("latitude", accomodationInfo.latitude);
      formData.append("longitude", accomodationInfo.longitude);
      formData.append("image", accomodationInfo.image);
      await AccomodationApi.Post(formData).then(() => {
        toast("숙소가 생성되었습니다.");
        navigate(-1);
      });
    } catch (error) {
      console.log(error);
      if (error.response?.status === 413) {
        toast(`이미지 용량을 초과하였습니다.`);
      } else {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    }
  };

  const execDaumPostcode = () => {
    let geocoder = new window.kakao.maps.services.Geocoder();
    new window.daum.Postcode({
      oncomplete: (data) => {
        if (data.userSelectedType === "R") {
          // 사용자가 도로명 주소를 선택했을 경우
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setAccomodationInfo({
                  ...accomodationInfo,
                  address: data.roadAddress,
                  latitude: result[0].y,
                  longitude: result[0].x,
                });
              }
            }
          );
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setAccomodationInfo({
                  ...accomodationInfo,
                  address: data.jibunAddress,
                  latitude: result[0].y,
                  longitude: result[0].x,
                });
              }
            }
          );
        }
      },
    }).open();
  };

  useEffect(() => {
    const getManager = async () => {
      try {
        const info = (await ManagerApi.Get(sessionStorage.getItem("id"))).data
          .data.content;
        setManagerInfo(info);
      } catch (error) {
        console.log(error);
      }
    };
    getManager();
  }, []);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-accomodation-edit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-accomodation-edit">
          <span>숙소 생성하기</span>
          <div>
            <span>기본정보</span>
            <div className="Manage-input-container Manage-input-container-space-add">
              <span className="Manage-input-title">등록관리자이메일</span>
              <input
                className="Manage-input-textarea manage-form-space-add-input"
                type="email"
                placeholder="이메일"
                disabled
                value={managerInfo.email}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">숙소명*</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input"
                type="text"
                placeholder="숙소명을 입력하세요"
                required
                value={accomodationInfo.name || ""}
                onChange={(e) => {
                  setAccomodationInfo((accomodationInfo) => ({
                    ...accomodationInfo,
                    name: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">주소*</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input accomodation-edit-search-address"
                type="text"
                placeholder="주소를 입력하세요"
                value={accomodationInfo.address}
                required
                onClick={execDaumPostcode}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-accomodation-edit">
              <span className="Manage-input-title">상세주소*</span>
              <input
                className="Manage-input-textarea manage-form-accomodation-edit-input"
                type="text"
                placeholder="상세주소를 입력하세요"
                value={accomodationInfo.addressDetail}
                onChange={(e) => {
                  setAccomodationInfo((accomodationInfo) => ({
                    ...accomodationInfo,
                    addressDetail: e.target.value,
                  }));
                }}
              />
            </div>

            {accomodationInfo.latitude && accomodationInfo.longitude && (
              <div
                className="Manage-input-container Manage-input-container-accomodation-edit"
                style={{ alignItems: "start" }}
              >
                <span className="Manage-input-title">좌표*</span>
                <div>
                  <Map
                    center={{
                      lat: parseFloat(accomodationInfo.latitude),
                      lng: parseFloat(accomodationInfo.longitude),
                    }}
                    style={{
                      width: "366px",
                      height: "366px",
                      borderRadius: "4px",
                    }}
                    level={2}
                    maxLevel={3}
                  >
                    <MapMarker
                      position={{
                        lat: parseFloat(accomodationInfo.latitude),
                        lng: parseFloat(accomodationInfo.longitude),
                      }}
                      draggable={true}
                      onDragEnd={(e) => {
                        const lat = e.getPosition().getLat();
                        const lon = e.getPosition().getLng();
                        setAccomodationInfo({
                          ...accomodationInfo,
                          lat,
                          lon,
                        });
                      }}
                    />
                  </Map>
                  <div className="map-position-info">
                    <div>위도 (y좌표) : {accomodationInfo.latitude}</div>
                    <div>경도 (x좌표) : {accomodationInfo.longitude}</div>
                  </div>
                </div>
              </div>
            )}
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">이미지</span>
              <div className="accomodation-edit-input-file-container">
                <label htmlFor="image-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="image-file-input"
                  className="Manage-input-textarea manage-form-accomodation-edit-input"
                  type="file"
                  onChange={(e) => {
                    accomodationImg(e);
                  }}
                />
                {accomodationInfo.imageUrl ? (
                  <div className="accomodation-img">
                    <img
                      className="uploaded-img"
                      src={accomodationInfo?.imageUrl}
                    />
                    <img
                      className="accomodation-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) => deleteImage()}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="Manage-form-save manage-form-save-accomodation-edit">
            <button className="cursorPointer" onClick={accomodationEdit}>
              저장하기
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageAccomodationAdd;
